import { useState } from "react";

const baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 14px",
  borderRadius: "999px",
  fontSize: "13px",
  fontWeight: 600,
  border: "1px solid",
  whiteSpace: "nowrap",
  transition: "all 0.2s ease",
};

const ActionButton = ({
  children,
  onClick,
  bgColor,
  textColor,
  borderColor,
  hoverBgColor,
  loading = false,
  disabled = false,
  disabledBgColor,
  disabledTextColor,
  disabledBorderColor,
  style = {},
}) => {
  const [hover, setHover] = useState(false);
  const isDisabled = disabled || loading;

  return (
    <button
      onClick={!isDisabled ? onClick : undefined}
      disabled={isDisabled}
      style={{
        ...baseStyle,

        backgroundColor: isDisabled
          ? disabledBgColor ?? bgColor
          : hover
          ? hoverBgColor || bgColor
          : bgColor,

        color: isDisabled
          ? disabledTextColor ?? textColor
          : textColor,

        borderColor: isDisabled
          ? disabledBorderColor ?? borderColor
          : borderColor,

        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.85 : 1,
        ...style,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
    {loading ? children + "..." : children}

    </button>
  );
};

export default ActionButton;
